import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { AccountUser } from './account-user';
export { AccountUser };
import { accountUserSchema } from '@schemas/business-objects/account-user';
import { AccountFormGroup } from './account-form-group';
import { UserFormGroup } from './user-form-group';

export class AccountUserFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    isAdmin: SchemaFormControl;
    isDesigner: SchemaFormControl;
    accountId: SchemaFormControl;
    account: AccountFormGroup;
    userId: SchemaFormControl;
    user: UserFormGroup;
  };

  declare value: Partial<AccountUser>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(accountUserSchema, AccountUser, data, options);
  }

  get object(): AccountUser {
    return new AccountUser(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'account':
        return new AccountFormGroup();
      case 'user':
        return new UserFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<AccountUser[]> {
    return AccountUser.find(filter);
  }

  static async findOne(filter?: any): Promise<AccountUser | null> {
    return AccountUser.findOne(filter);
  }

  static async findById(id: number, filter?: any): Promise<AccountUser> {
    return AccountUser.findById(id, filter);
  }

  static async create(data: Partial<AccountUser>): Promise<AccountUser> {
    return AccountUser.create(data as any);
  }

  static async updateById(
    id: number,
    updates: Partial<AccountUser>,
  ): Promise<AccountUser> {
    return AccountUser.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return AccountUser.deleteById(id);
  }
}

export class AccountUserFormArray extends PersistedFormArray {
  declare controls: AccountUserFormGroup[];

  readonly entityName = 'AccountUser' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(accountUserSchema, AccountUser, options);
  }

  protected override createItemGroup() {
    return new AccountUserFormGroup();
  }

  get array(): AccountUser[] {
    return this.controls.map((group: AccountUserFormGroup) => group.object);
  }
}

export class AccountUserPersistedArray extends PersistedArray<AccountUser> {
  readonly entityName = 'AccountUser' as const;

  constructor(options?: PersistedArrayOptions) {
    super(AccountUser, options);
  }
}
